<ion-content>
    <ion-toolbar>
      <div class="btn-back-menu" (click)="onBackMenu()">
          <button ion-button clear color="light" no-padding>
            <ion-icon large name="arrow-back" style="font-size: 26px;padding-right: 3px;color:#294F94"></ion-icon>
              <!-- <strong style="color:#294F94 !important" class="margin-sides">{{ 'GLOBAL_CANCEL' | translate}}</strong> -->
              <p style="color:#294F94; font-size: 16px;" class="margin-sides">Zurück</p>
          </button>
          <ion-title class="title">Edit athlete data</ion-title>
        </div>
    </ion-toolbar>
    <ion-list>
        <div class="background-container">
        <div circle class="user-avatar">
            <ion-icon color="white" style="font-size: 40px;"name="camera"></ion-icon>   
        </div>
      </div>
        <ion-item class="w-100">
            <ion-label fixed class="data-label">Athlete firstname</ion-label>
          <ion-input
            type="text"
            large
            placeholder="{{athleteData.firstName}}"
            [(ngModel)]="athleteData.firstName"
          ></ion-input>
        </ion-item>
        <ion-item class="w-100">
          <ion-label fixed class="data-label">Athlete surname</ion-label>
        <ion-input
          type="text"
          large
          placeholder="{{athleteData.lastName}}"
          [(ngModel)]="athleteData.lastName"
        ></ion-input>
      </ion-item>
        <ion-item class="w-100">
            <ion-label fixed class="data-label">Athlete bib number</ion-label>
          <ion-input
            type="text"
            large
            placeholder="{{athleteData.bibNo}}"
            [(ngModel)]="athleteData.bibNo"
          ></ion-input>
        </ion-item>
        <ion-item class="w-100">
            <ion-label fixed class="data-label">Athlete time</ion-label>
          <!-- <ion-input
            type="time" step="1"
            large
            placeholder="{{athleteData.time}}"
            [(ngModel)]="athleteData.time"
          ></ion-input> -->
          <ion-datetime style="display: flex;align-items: center; background-color: rgb(243,243,243); width: 100%"displayFormat="HH:mm:ss" [(ngModel)]="athleteData.time"></ion-datetime>
        </ion-item>
      </ion-list>
</ion-content>
